import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api-client';
import { getBoot } from '@/lib/boot';

export type PlatformInfo = {
  trial_micro_usd: number;
  text_model_count: number;
  image_model_count: number;
  prompt_template_count: number;
  text_model_families: Array<{ family: string; label: string; count: number }>;
  trial_sample: { articles_at_cheapest: number };
};

/** Public stats endpoint — fine to call without auth. Landing + Pricing
 *  use this to show live numbers instead of hardcoded marketing copy.
 *
 *  Seeded from window.__BOOT__.platform_info (injected by the worker
 *  into index.html) so the first paint already has the right counts. */
export function usePlatformInfo() {
  return useQuery({
    queryKey: ['public', 'platform-info'],
    queryFn: () => api.get<PlatformInfo>('/api/public/platform-info'),
    staleTime: 10 * 60 * 1000,
    initialData: () => getBoot().platform_info,
  });
}
